// extracted by mini-css-extract-plugin
module.exports = {"root":"Entry_root__xK5RU","paper":"Entry_paper__2rbU9","details":"Entry_details__fGIsV"};